import React, { Component } from 'react';
import { Box, Fab } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import CreditsList from './CreditsList';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import DebitsList from './DebitsList';
import { AddRounded } from '@mui/icons-material';
import CreditForm from './CreditForm';

class CreditsGeneral extends Component {
    state = { 
        index: 0,
        openForm: false,
        creditDemandId: "",
        creditDemandName: "",
        creditsForUserId: ""
    }

    componentDidMount = () => {
        // Vérifier si le paramètre ?new=true est présent dans l'URL
        const params = new URLSearchParams(window.location.search);
        const newParam = params.get('new');
        const spendingDemandId = params.get('spending_demand_id');
        const spendingDemandNameParam = params.get('spending_demand_name');
        const spendingDemandName = spendingDemandNameParam || "";
        const creditsForUserId = params.get('credits_for_user_id');
        
        if (newParam === 'true') {
            this.setState({ 
                openForm: true,
                creditDemandId: spendingDemandId || "",
                creditDemandName: spendingDemandName,
                creditsForUserId: creditsForUserId || ""
            });
            // Nettoyer l'URL pour retirer le paramètre après ouverture de la modale
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }

    render() {
        const { openForm } = this.state;
        return (
            <Box>
                {openForm &&
                    <CreditForm 
                        open={openForm} 
                        handleClose={() => this.setState({ openForm: false, creditDemandId: "", creditDemandName: "", creditsForUserId: "" })} 
                        credit_demand_id={this.state.creditDemandId}
                        credit_demand_name={this.state.creditDemandName}
                        credits_for_user_id={this.state.creditsForUserId}
                        {...this.props} 
                    />
                }
                <TitleWithEndAction
                    title={this.state.index === 0 ? "Liste des Avances" : "Liste des Retours sur Avance"}
                    action={() => this.props.openFormDownload("/extract/credits")}
                    actionTitle="Télécharger" 
                    disabled={this.props.downloading}
                >
                    <Fab 
                        variant="contained" 
                        color="secondary" 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Nouvelle Avance"
                        size="small"
                    >
                        <AddRounded />                        
                    </Fab>
                </TitleWithEndAction>
                
                <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Avances", "Retours"]}
                >
                    <CreditsList
                        {...this.props}
                        {...this.state}
                    />
                    <DebitsList
                        {...this.props}
                        {...this.state}
                    />
                </SwipeableTabs>
            </Box>
        );
    }
}

export default CreditsGeneral;